import { Pipe, PipeTransform } from '@angular/core';
import { rgbaStringToHex } from '@finxone-platform/shared/sys-config-types';

@Pipe({
  name: 'rgbaToHex',
})
export class RgbaToHexPipe implements PipeTransform {
  transform(value: string): string {
    return rgbaStringToHex(value);
  }
}
